import { get } from 'lodash-es'

import { NavFlags, NavItem, ResolvedNavItem } from './SidebarNav.types'

/** An item with no flag is always visible; a flagged item needs the flag on. */
export const isNavItemVisible = (item: NavItem, flags: NavFlags): boolean =>
  !item.flag || Boolean(get(flags, item.flag, false))

/** Subbie accounts see Map Overview as an upsell rather than a working link. */
export const isNavItemBlocked = (item: NavItem, isSubbie: boolean): boolean =>
  Boolean(item.blockedForSubbies && isSubbie)

/**
 * Gating is an access requirement, not a presentation detail. This is the check
 * that must guard the point of navigation, not just the point of rendering — a
 * row that looks disabled but still responds to Enter is a bug.
 */
export const isNavItemNavigable = (item: NavItem, flags: NavFlags, isSubbie: boolean): boolean =>
  isNavItemVisible(item, flags) && !isNavItemBlocked(item, isSubbie)

/** The items the current user may see, in config order, with blocking resolved. */
export const resolveNavItems = (
  items: NavItem[],
  flags: NavFlags,
  isSubbie: boolean,
): ResolvedNavItem[] =>
  items
    .filter((item) => isNavItemVisible(item, flags))
    .map((item) => ({ ...item, isBlocked: isNavItemBlocked(item, isSubbie) }))
